import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ToastProvider } from "@/components/ToastContainer";
import VersionChecker from "@/components/VersionChecker";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AdminPanel from "@/pages/AdminPanel";
import Calculator from "@/pages/Calculator";
import CalculationHistory from "@/pages/CalculationHistory";
import ProposalList from "@/pages/ProposalList";
import ProposalView from "@/pages/ProposalView";
import FeeTableCalculator from "@/pages/FeeTableCalculator";
import FeeTableAnalyticsStatic from "@/pages/FeeTableAnalyticsStatic";
import Dashboard from "@/pages/Dashboard";
import UnifiedSettings from "@/pages/UnifiedSettings";
import SettingsManager from "@/pages/SettingsManager";
import MerchantFeeManager from "@/pages/MerchantFeeManager";
import AccountExecutiveManager from "@/pages/AccountExecutiveManager";
import Analytics from "@/pages/Analytics";
import AdvancedAnalytics from "@/pages/AdvancedAnalytics";
import ProfitabilityAnalysis from "@/pages/ProfitabilityAnalysis";
import Approvals from "@/pages/Approvals";
import SaasAgreement from "@/pages/SaasAgreement";
import AgreementsList from "@/pages/AgreementsList";
import AgreementTemplateEditor from "@/pages/AgreementTemplateEditor";
import SaasAgreementForm from "@/pages/SaasAgreementForm";
import UserManagement from "@/pages/UserManagement";
import AuditLog from "@/pages/AuditLog";
import AccountCodeSettings from "@/pages/AccountCodeSettings";
import ComparisonView from "@/pages/ComparisonView";
import Profile from "@/pages/Profile";
import DataSnapshot from "@/pages/DataSnapshot";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <ToastProvider>
      <div className="App">
        <BrowserRouter>
          <VersionChecker />
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/landing" element={<Landing />} />
            
            {/* Protected routes with Layout (Sidebar) */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
          
          <Route path="/calculator" element={
            <ProtectedRoute>
              <Layout>
                <Calculator />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/proposals" element={
            <ProtectedRoute>
              <Layout>
                <ProposalList />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/proposal/:proposalId" element={
            <ProtectedRoute>
              <Layout>
                <ProposalView />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/calculation-history" element={
            <ProtectedRoute>
              <Layout>
                <CalculationHistory />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/settings" element={
            <ProtectedRoute>
              <Layout>
                <UnifiedSettings />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/fee-table-calculator" element={
            <ProtectedRoute>
              <Layout>
                <FeeTableCalculator />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/fee-analytics-static" element={
            <ProtectedRoute>
              <Layout>
                <FeeTableAnalyticsStatic />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/analytics" element={
            <ProtectedRoute>
              <Layout>
                <Analytics />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/analytics/advanced" element={
            <ProtectedRoute>
              <Layout>
                <AdvancedAnalytics />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/profitability" element={
            <ProtectedRoute>
              <Layout>
                <ProfitabilityAnalysis />
              </Layout>
            </ProtectedRoute>
          } />

          
          <Route path="/users" element={
            <ProtectedRoute>
              <Layout>
                <UserManagement />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/approvals" element={
            <ProtectedRoute>
              <Layout>
                <Approvals />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/agreements" element={
            <ProtectedRoute>
              <Layout>
                <AgreementsList />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/agreement-template" element={
            <ProtectedRoute>
              <Layout>
                <AgreementTemplateEditor />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/agreement/:collectionId" element={
            <ProtectedRoute>
              <Layout>
                <SaasAgreementForm />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/audit-log" element={
            <ProtectedRoute>
              <Layout>
                <AuditLog />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/account-code-settings" element={
            <ProtectedRoute>
              <Layout>
                <AccountCodeSettings />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/compare" element={
            <ProtectedRoute>
              <Layout>
                <ComparisonView />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/settings-manager" element={
            <ProtectedRoute>
              <Layout>
                <UnifiedSettings />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/merchant-fees" element={
            <ProtectedRoute>
              <Layout>
                <MerchantFeeManager />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/account-executives" element={
            <ProtectedRoute>
              <Layout>
                <AccountExecutiveManager />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/settings" element={
            <ProtectedRoute>
              <Layout>
                <UnifiedSettings />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/profile" element={
            <ProtectedRoute>
              <Layout>
                <Profile />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/user-management" element={
            <ProtectedRoute>
              <Layout>
                <UserManagement />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/data-snapshot" element={
            <ProtectedRoute>
              <Layout>
                <DataSnapshot />
              </Layout>
            </ProtectedRoute>
          } />

          
          {/* Legacy admin route - redirect to dashboard */}
          <Route path="/admin" element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
    </ToastProvider>
  );
}

export default App;
